import { runImpactCalculateTourCo2ForProject } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-co2-for-project.action';
import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getTourTravels } from './get-tour-travels.action';

type Params = {
  tourTravelId: number;
  sequenceId: number;
};

export const deleteTourTravel = createAppAsyncThunk(
  'projectTourOntour/deleteTourTravel',
  async (
    params: Params,
    {
      extra: { projectTourOntourGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<void> => {
    try {
      await projectTourOntourGateway.deleteTravel(params.tourTravelId);
      await dispatch(getTourTravels({ sequenceId: params.sequenceId }));
      const projectId = selectCurrentProjectTour(getState())?.id || -1;
      await dispatch(runImpactCalculateTourCo2ForProject({ projectId }));
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteTourTravel.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteTourTravel.Message.error'));
}
